import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

import { isInWujie, WujieBusEnum } from '@common/utils'
import { bus } from 'wujie'
import { useLoginInfo } from '@/hooks'
import { useStore } from './store'
import { cache } from './utils'


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const { setLoginInfo } = useLoginInfo()
const setupWujie = () => {
	const { userInfo, tokenInfo } = window.$wujie.props?.state || {}
	const project = window.$wujie.props?.project || ''
	const examTabType = window.$wujie.props?.examTabType || ''
	if (project) {
		cache.set('projectType', project)
	}
	// cache.set('examTabType', examTabType)
	if (examTabType) {
		cache.set('examTabType', examTabType)
	}
	if (userInfo && tokenInfo) {
		setLoginInfo({ userInfo, tokenInfo })
	}
	bus.$on(WujieBusEnum.SYNC_STATE, (res) => {
		// TODO: 增加重定向处理
		console.log('🚀 ~ e接收到' + WujieBusEnum.SYNC_STATE, res)
		setLoginInfo(res)
	})
}
console.log(isInWujie(), '是否无界')

isInWujie() && setupWujie()

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view, null, {
    default: _withCtx(({ Component }) => [
      (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
    ]),
    _: 1
  }))
}
}

})